export default __webpack_public_path__ + "6273322948631f941cec336e0c265889.svg";